import { Col, Row } from "reactstrap"
import Search from "../../../../../components/common/Search/Search"
import PageCard from "../../../../../components/SellerPortalComponents/Settings/StoreSetting/PageCard"
import { useState } from "react"
import { CiMobile1 } from "react-icons/ci"
import { GrDesktop } from "react-icons/gr"
import ViewToggleTabs from "../../../../../components/SellerPortalComponents/Settings/ViewToggleTabs/ViewToggleTabs"
import { useNavigate } from "react-router-dom"
import WhiteButton from "../../../../../components/SellerPortalComponents/Settings/WhiteButton/WhiteButton"

const CustomPages = () => {

  const navigate = useNavigate()

  const [content, setContent] = useState(
    `<h2>About Us</h2>
    <p>At <strong>(Store/Brand name)</strong>, we specialize in providing top-quality electronics and accessories. Founded in 2010, we have grown to become a trusted name in the industry, known for our innovative products and exceptional customer service.</p>
    <h3>Our Mission</h3>
    <p>Our mission is to deliver cutting-edge technology that enhances everyday life. We strive to exceed customer expectations through continuous innovation and a commitment to excellence.</p>
    <h3>Our Story</h3>
    <p><strong>(Brand Name)</strong> was founded by tech enthusiasts who saw a gap in the market for high-quality, affordable electronics. From our humble beginnings in a small garage, we have grown into a global brand, thanks to our dedication to quality and customer satisfaction.</p>
    <h3>Our Values</h3>
    <ul>
      <li><strong>Customer Focus:</strong> We prioritize our customers’ needs and work tirelessly to meet them.</li>
      <li><strong>Innovation:</strong> We embrace new ideas and technologies to stay ahead of the curve.</li>
      <li><strong>Integrity:</strong> We conduct our business with honesty and transparency.</li>
      <li><strong>Quality:</strong> We are committed to delivering products of the highest quality.</li>
      <li><strong>Sustainability:</strong> We strive to minimize our environmental impact through sustainable practices.</li>
    </ul>`
  )

  const tabs = [
    { id: "desktop", label: "Desktop Version", icon: <GrDesktop /> },
    { id: "mobile", label: "Mobile Version", icon: <CiMobile1 /> },
  ]
  const [activeTab, setActiveTab] = useState(tabs[0].id)

  const pageCardData = [
    {
      id: 1,
      title: "About Us",
      createdOn: "13/07/2024",
      modifiedOn: "13/07/2024",
      status: "Online",
      bordered: true,
    },
    {
      id: 2,
      title: "About Us 1",
      createdOn: "10/07/2024",
      modifiedOn: "12/07/2024",
      status: "Offline",
      bordered: false,
    },
    {
      id: 3,
      title: "About Us 2",
      createdOn: "05/07/2024",
      modifiedOn: "11/07/2024",
      status: "Online",
      bordered: false,
    },
  ]

  return (
    <Row className="mt-3">
      <Col>
        <div className="bg-white d-flex align-items-center justify-content-between" style={{ borderBlock: "4px solid #FBBD34", padding: ".4rem" }}>
          <div className="fs-5 fw-semibold">Custom Pages</div>
          <div className="d-flex gap-2">
            <WhiteButton onClick={() => navigate("/settings/create-custom-page")}>Create New</WhiteButton>
            <Search />
          </div>
        </div>

        <div className="p-2 bg-white shadow">
          {pageCardData.map((page) => (
            <PageCard key={page.id} title={page.title} createdOn={page.createdOn} modifiedOn={page.modifiedOn} status={page.status} bordered={page.bordered} />
          ))}
        </div>
      </Col>
      <Col>
        <div className="bg-white px-2 py-1 mb-2">
          <ViewToggleTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>

        <div className="bg-white mt-3 p-4 shadow" dangerouslySetInnerHTML={{ __html: content }} />
      </Col>
    </Row>
  )
}

export default CustomPages
